import classnames from 'classnames'
import { useTranslation } from 'next-i18next'

import { useStatsigDynamicLocaleConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-locale-config.hook'

import { ReadMore } from '../readMore'
import ReviewMetaRow from '../reviews/reviewMetaRow/ReviewMetaRow'
import ReviewStars from '../reviews/reviewStars'

import stylesV2 from './productReviewHighlightV2.module.scss'

import type { ReviewMetaRowProps } from '../reviews/reviewMetaRow/ReviewMetaRow'

export interface ProductReviewHighLightProps extends ReviewMetaRowProps {
  title: string
  avgRating: number
  children: string
  className?: string
  brandName?: string
}

const ProductReviewHighLight = ({
  children,
  className,
  avgRating,
  title,
  brandName,
  reviewedInCountry,
  isIncentivized,
  rewardProgrammeLearnMoreUrl,
}: ProductReviewHighLightProps) => {
  const { t } = useTranslation('common')
  const localeConfig = useStatsigDynamicLocaleConfig()
  const finalStyles = stylesV2

  const classes = classnames(finalStyles.container, className)

  return (
    <div className={classes}>
      <ReviewStars totalStars={5} fillStars={avgRating} />
      <div className={finalStyles.container__title}>{title}</div>
      <ReadMore className={finalStyles.container__body}>{children}</ReadMore>
      {/* US/CA (displayLocalisedReviewSize=false): keep the existing standalone brand line unchanged.
          UK: the brand is rendered inline inside ReviewMetaRow via sourceBrand instead. */}
      {!localeConfig.displayLocalisedReviewSize && brandName && (
        <p className={finalStyles.brandName}>
          {t('customer_review_from')} {brandName}
        </p>
      )}
      <ReviewMetaRow
        sourceBrand={brandName}
        reviewedInCountry={reviewedInCountry}
        isIncentivized={isIncentivized}
        rewardProgrammeLearnMoreUrl={rewardProgrammeLearnMoreUrl}
      />
    </div>
  )
}
export default ProductReviewHighLight
